import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AuthenticationService } from './auth.service';
import { APPCONFIG } from '../config/config';
import { Campaign } from '../models/campaign.model';
import { parse, min, format, max } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class HelpersServicesService {

  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient
  ) { }

  getQuery( query: string ) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`
    });
    const URL = `${ APPCONFIG.endpoints.services }/${ query }`;
    return this.http.get( URL, { headers } );
  }

  getQueryFile( query: string ) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`,
      responseType: 'arraybuffer'
    });
    const URL = `${ APPCONFIG.endpoints.services }/${ query }`;
    return this.http.get( URL, { headers } );
  }

  getBlobQuery(query: string, params: any = {}) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`
    });
    const URL = `${ APPCONFIG.endpoints.services }/${ query }`;
    return this.http.get(URL, { headers, params, responseType: 'blob' });
  }

  postQuery( query: string, data: any ) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`
    });
    return this.http.post( `${ APPCONFIG.endpoints.services }/${ query }`, data, { headers } );
  }

  putQuery( query: string, data: any ) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`
    });
    return this.http.put( `${ APPCONFIG.endpoints.services }/${ query }`, data, { headers } );
  }

  deleteQuery( query: string ) {
    const headers = new HttpHeaders({
      Authorization: `${ this.authenticationService.token.token_type } ${ this.authenticationService.token.access_token }`
    });
    return this.http.delete( `${ APPCONFIG.endpoints.services }/${ query }`, { headers } );
  }

  getFirstDateBudgetCircuits(campaign: Campaign) {
    if (!campaign.budget_circuit?.length) {
      return null;
    }

    const dates = [];

    campaign.budget_circuit.forEach(circuit => {
      const firstDate = circuit?.payload?.dates?.[0];

      if (firstDate && firstDate.year && firstDate.month && firstDate.day) {
        const year = firstDate.year;
        const month = firstDate.month.toString().padStart(2, '0');
        const day = firstDate.day.toString().padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        dates.push(parse(dateString, 'yyyy-MM-dd', new Date()));
      }
    });

    if (dates.length === 0) {
      return null;
    }

    const oldestDate = min(dates);

    return format(oldestDate, 'yyyy-MM-dd') ?? null;
  }

  getLastDateBudgetCircuits(campaign: Campaign) {
    if (!campaign.budget_circuit?.length) {
      return null;
    }

    const dates = [];
    
    campaign.budget_circuit.forEach(circuit => {
      const dateArray = circuit?.payload?.dates;

      if (Array.isArray(dateArray) && dateArray.length > 0) {
        const lastDate = dateArray[dateArray.length - 1];

        if (lastDate?.year && lastDate?.month && lastDate?.day) {
          const year = lastDate.year;
          const month = lastDate.month.toString().padStart(2, '0');
          const day = lastDate.day.toString().padStart(2, '0');
          const dateString = `${year}-${month}-${day}`;
          dates.push(parse(dateString, 'yyyy-MM-dd', new Date()));
        }
      }
    });

    if (dates.length === 0) {
      return null;
    }

    const mostRecentDate = max(dates);

    return format(mostRecentDate, 'yyyy-MM-dd') ?? null;
  }

}
